"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.List = void 0;
const React = require("react");
const mobx_react_1 = require("mobx-react");
const image_header_1 = require("@festival/page-configuration/image-header");
const alternative_content_1 = require("@festival/page-configuration/alternative-content");
const list_content_1 = require("@festival/press/list-content");
class List extends React.Component {
    render() {
        return (React.createElement(React.Fragment, null,
            React.createElement(image_header_1.default, null),
            React.createElement(alternative_content_1.default, null,
                React.createElement(list_content_1.default, null))));
    }
}
exports.List = List;
exports.default = mobx_react_1.inject('routeManager')(mobx_react_1.observer(List));
